import { Page } from '@commerce/types'
import { Layout } from '@components/common'
import commerce from '@lib/api/commerce'
import getGlobalStaticProps from '@lib/get-global-static-props'
import { createClient, getDocByUid } from '@lib/prismicio'
import { SliceZone } from '@prismicio/react'
import { PrismicDocument } from '@prismicio/types'
import { AnalyticsPageType } from '@shopify/hydrogen-react'
import type { GetStaticPropsContext } from 'next'
import { GetStaticPathsContext } from 'next'
import { NextSeo } from 'next-seo'
import { components } from 'slices'

export async function getStaticProps({
  params,
  preview,
  previewData,
  locale,
  locales,
}: GetStaticPropsContext<{ slug: string }>) {
  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)

  const config = { locale, locales }

  const shopifyPagePromise = commerce.getPageByHandle({
    variables: { handle: params!.slug },
    config,
    preview,
  })

  const prismicDocPromise = getDocByUid(
    'landing-page',
    params!.slug,
    client,
    locale
  )

  const { page: shopifyPage } = await shopifyPagePromise
  const prismicDoc: PrismicDocument | null = await prismicDocPromise

  if (!prismicDoc) {
    return {
      notFound: true,
    }
  }

  let metaValues: Page.Seo = { description: null, title: null }

  if (shopifyPage) {
    metaValues = shopifyPage.seo || metaValues
  }

  return {
    props: {
      ...globalProps,
      metaValues,
      prismicDoc,
      analyticsPayload: {
        pageType: AnalyticsPageType.page,
      },
    },
    revalidate: 60,
  }
}

export async function getStaticPaths({ locales }: GetStaticPathsContext) {
  return {
    paths: ['/jewellery'],
    fallback: 'blocking',
  }
}

// Inferring from static props doesnt seem to work here

type PageProps = {
  metaValues: {
    title: string
    description: string
  }
  prismicDoc: PrismicDocument | null
}

export default function Slug({ metaValues, prismicDoc }: PageProps) {
  const { description, title } = metaValues
  console.log(prismicDoc?.data.slices, 'slice information')
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          type: 'website',
          title,
          description,
        }}
      />
      <SliceZone slices={prismicDoc?.data.slices} components={components} />
    </>
  )
}

Slug.Layout = Layout
